import axios from "axios";
import env from "../variables/EndpointEnvironment";

const newsLimitAPI = (props) => {
  return axios.get(`${env.HOST}/news?loc=${props.loc}&page=${props.page}&perPage=${props.limit}`, {
    headers: {
      "Content-Language": localStorage.getItem('i18nextLng'),
    },
  });
};

export default newsLimitAPI;
